import {NamaPresenter} from "./NamaPresenter";
import * as urls from "../constants/NamaURLS";
import {ajaxJSON} from "../common/NamaCommon";
import {currentUserId} from "../login/LoginPresenter";
import {ReportLauncherView} from "../views/ReportLauncherView";
import {QuestionFieldsSerializer} from "../common/CriteriaAndQuestionsURLParser";
import {getIds, getSubList} from "../common/HasIDUtil";
import {overrideDimensionsIfNeed} from "./ReportDimensionParametersOverrider";
import * as places from "./places";
import * as PrintingOption from "../constants/PrintingOption";
import * as DownloadPurpose from "../constants/DownloadPurpose";
import {NamaRouterInstance} from "./NamaRouter";
import {openUrlInNewWindow} from "../common/NaMaPrinting";
import {ReportViewerPresenter} from "./ReportViewerPresenter";
import * as Translator from "../common/Translator";
import {attachNextAndPreviousFocus} from "./EditPresenter";

export class ReportLauncherPresenter extends NamaPresenter {
    start() {
        let that = this;
        that.entityType = "ReportDefinition";
        if (!that.place)
            return;
        ajaxJSON(urls.FetchReportMetadata, {
                request: JSON.stringify({
                    id: that.place.reportId,
                    entityType: that.entityType,
                    userId: currentUserId()
                })
            }, (result) => {
                that.reportRef = result.data.report;
                that.metadataContainer = result.data;
                that.init(result.data.metadata);
            }
        );
    }

    init(repMetadata) {
        let that = this;
        /**
         * @type namaTypes.ReportMetadata
         */
        that.reportMetaData = repMetadata;
        if (!repMetadata.questionFields || repMetadata.questionFields.length === 0) {
            that.showReportResult(that.createReportResultPlace(""));
            return;
        }
        that.startView();
    }

    startView() {
        let that = this;
        let exampleDiv = that.reportContainer;
        if (!that.embeddedReportView) {
            exampleDiv = $("#main-wrapper").find("#example.page-content-wrapper");
        }
        exampleDiv.html("");
        that.view = new ReportLauncherView(that);
        that.view.render().appendTo(exampleDiv);
        attachNextAndPreviousFocus(exampleDiv);
    }

    rootElement() {
        return this.view.rootElement;
    }

    defaultParameterValues() {
        let that = this;
        let defaultValues = createDefaultValues(that.reportMetaData);
        let questionsFromURL = new QuestionFieldsSerializer().questionsFromURL(that.place.questions);
        if (questionsFromURL) {
            defaultValues.removeAll(getSubList(defaultValues, getIds(questionsFromURL)));
            defaultValues.push(...questionsFromURL);
        }
        overrideDimensionsIfNeed(defaultValues, that.metadataContainer);
        return defaultValues;
    }

    onClick(inNewWindow, format) {
        let that = this;
        if (that.questionFieldsEditor.isAnyRequiredFieldEmpty())
            return;
        let questionFields = that.view.questionFields;
        let questionFieldsURL = new QuestionFieldsSerializer().toURL(questionFields);
        let reportResultPlace = that.createReportResultPlace(questionFieldsURL, inNewWindow);
        reportResultPlace.format = format;
        this.showReportResult(reportResultPlace, inNewWindow);
    }

    showReportResult(reportResultPlace, inNewWindow) {
        let that = this;
        if (inNewWindow) {
            let url = reportResultPlace.fullLink();
            openUrlInNewWindow(url);
        }
        else {
            if (that.embeddedReportView) {
                that.viewPresenter = new ReportViewerPresenter(reportResultPlace);
                that.viewPresenter.embeddedViewContainer = reportResultPlace.embeddedViewContainer;
                that.viewPresenter.embeddedReportView = reportResultPlace.embeddedReportView;
                that.viewPresenter.viewHeight = that.viewHeight;
                that.viewPresenter.viewWidth = that.viewWidth;
                that.viewPresenter.start();
            }
            else {
                NamaRouterInstance.goTo(reportResultPlace);
            }
        }
    }

    createReportResultPlace(questionFieldsURL, inNewWindow) {
        let that = this;
        let place = new places.ReportViewerPlace();
        place.questions = questionFieldsURL;
        place.reportId = this.place.reportId;
        place.printingOption = PrintingOption.NONE;
        place.purpose = DownloadPurpose.PREVIEW;
        place.embeddedReportView = that.embeddedReportView;
        if (that.reportContainer && !inNewWindow)
            that.reportContainer.html("");
        place.embeddedViewContainer = that.reportContainer;
        place.lang = Translator.currentLanguage();
        return place;
    }

    onRefresh() {
        //TODO needs fix
        this.startView();
    }
}

export function createDefaultValues(reportMetaData) {
    let defaultValues = [];
    if (!reportMetaData || !reportMetaData.metadata)
        return defaultValues;
    for (let questionFieldMetadata of reportMetaData.metadata) {
        if (questionFieldMetadata.defaultValue) {
            defaultValues.push({id: questionFieldMetadata.id, value: questionFieldMetadata.defaultValue});
        }
    }
    return defaultValues;
}